import bloquear from '@/core/store/item-ata/bloqueio/bloquear'
import historico from '@/core/store/item-ata/bloqueio/historico'

export default {
	modules: {
		bloquear,
		historico,
	},
}
